//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { commonApi } from '@/common/index'
  import { resetTextBylangKey, platformPartOptions, bonusTypeOptions } from '../../../libs/options.js'
  import lockMX from './mixins/lockMX.js'
  import { unique } from '@/common/utils/'

  export default {
    name: 'discountsList',
    mixins: [lockMX],
    data() {
      return {
        status: [ // 锁定状态
          {name: '全部状态',value: '', langKey: 'all' },
          {name: '锁定中',value: '1', langKey: 'lock' },
          {name: '已解锁',value: '2', langKey: 'unlock' },
          {name: '已取消',value: '4', langKey: 'cancel' }
        ],

        lockStatus: [''],
        isShowPlatformDialog: false,
        allPlatform: [], // 所有平台
        platformStatus: [''], // 当前平台
        isShowTypeDialog: false,
        bonusStatus: [''], //当前优惠类型
        discountsList: [],
      }
    },
    computed: {
      bonusOptions() { // 红利类型
        return [resetTextBylangKey(bonusTypeOptions, this.$t('mine').lockAmount.bonusTypeOption, 'name')]
      }
    },
    created() {
      this._getAllPlatform() // 获取筛选条件平台数据
      this.depositQueryUserLockAmount()
    },
    methods: {
      _getAllPlatform() { // 获取筛选条件平台数据
        commonApi.PAY.getAllPlatform().then(data => {
          let list = resetTextBylangKey(platformPartOptions, this.$t('mine').lockAmount.platformOption, 'name') // 平台部分数据翻译
          if (data.length > 0) {
            data.forEach((item, index) => {
              const { fullName, platformCode } = item
              list.push({ name: platformCode, value: platformCode })
            })
          }
          this.allPlatform = [unique(list, 'value')]
        }).catch(err => {})
      },

      closeSearch(type) { // 关闭条件选择
        this._setConditionName(type)
        this.pageNo = 1;
        this.isShowDialog = false;
        this.isShowPlatformDialog = false;
        this.isShowTypeDialog = false;
        if (this.$refs.loadMoreEle) this.$refs.loadMoreEle.scrollToTop()
        this.depositQueryUserLockAmount();
      },

      _getParams() { // 获取请求参数
        return {
          UUID: this.UUID,
          lockType: 'bonus',
          startTime: '',
          platformCode: this.platformStatus[0],
          status: this.lockStatus[0],
          type: this.bonusStatus[0],
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/LockAmount/discountsList.vue